export default {
  image: 's2.jpg',
  productData: {
    name: 'Effizientes Standardsystem S2',
    shorthand: "S2",
    advantages: [
      "Schnelle Verarbeitung",
      "Einfache Verarbeitung",
      "Streiflichtunempfindlich",
      "Zeitsparend"
    ],
    technical: [
      "Feuchtraum WO-I",
      "Glatte Flächen",
      "höchste Brandklassifizierung",
      "Glanzgrad stumpfmatt",
      "Erhöhte optische Ansprüche",
      "TÜV"
    ],
    systemStructure: [
      {
        type: 'subsurface',
        layer: 1,
        products: [0],
        selectedProduct: 0,
        changedProduct: false
      },
      {
        type: 'joints',
        layer: 2,
        products: [1],
        selectedProduct: 1,
        changedProduct: false
      },
      {
        type: 'surfaceFilling',
        layer: 3,
        products: [9],
        selectedProduct: 9,
        changedProduct: false
      },
      {
        type: 'firstCoat',
        layer: 4,
        products: [10],
        selectedProduct: 10,
        changedProduct: false
      },
      {
        type: 'wallCovering',
        layer: 5,
        products: [11],
        selectedProduct: 11,
        changedProduct: false
      },
      {
        type: 'finalCoatLayer1',
        layer: 6,
        products: [12, 27, 44],
        selectedProduct: 12,
        changedProduct: false
      },
      {
        type: 'finalCoatLayer2',
        layer: 6,
        products: [12, 27, 44],
        selectedProduct: 12,
        changedProduct: false
      }
    ],
    construction: {
      composition: [
        {
          title: { de: 'Systemgruppen' },
          output: 'Effizientes Standardsystem',
          type: 'systemGroup',
          value: 'systemgroup-1'
        },
        {
          title: { de: 'Räume' },
          output: 'Wohnräume',
          type: 'room',
          value: 'room-1'
        },
        {
          title: { de: 'Räume' },
          output: 'Bad',
          type: 'room',
          value: 'room-2'
        },
        {
          title: { de: 'Räume' },
          output: 'Flur',
          type: 'room',
          value: 'room-4'
        },
        {
          title: { de: 'Räume' },
          output: 'Keller',
          type: 'room',
          value: 'room-5'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'Schadstoffgeprüft',
          type: 'environmentHealth',
          value: 'environmenthealth-1'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'TÜV',
          type: 'environmentHealth', 
          value: 'environmenthealth-2'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'Öko Tex',
          type: 'environmentHealth', 
          value: 'environmenthealth-5'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Streiflichtunempfindlich',
          type: 'resilience', 
          value: 'resilience-2'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Desinfektionsmittelbeständig',
          type: 'resilience', 
          value: 'resilience-5'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Risssicher',
          type: 'resilience', 
          value: 'resilience-6'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Matt',
          type: 'designSurface', 
          value: 'designsurface-1'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Glatt',
          type: 'designSurface', 
          value: 'designsurface-6'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Erhöhte optische Ansprüche',
          type: 'designSurface', 
          value: 'designsurface-8'
        },
        {
          title: { de: 'Verarbeitung' },
          output: 'Einfach',
          type: 'processing', 
          value: 'processing-1'
        },
        {
          title: { de: 'Verarbeitung' },
          output: 'Schnell',
          type: 'processing', 
          value: 'processing-4'
        },
        {
          title: { de: 'Verarbeitungszeit' },
          output: 'Stufe 1',
          type: 'processingTime', 
          value: 'processingtime-1'
        },
        {
          title: { de: 'Preisniveau' },
          output: '€',
          type: 'priceLevel', 
          value: 'pricelevel-1'
        }
      ]
    }
  }
}
